import {
  CreateProjectRequest,
  CreateProjectResponse,
  GetProjectRequest,
  GetProjectResponse,
  UpdateProjectRequest,
  UpdateProjectResponse,
  UpdateProjectStakeholdersRequest,
  UpdateProjectStakeholdersResponse,
  DeleteProjectStakeholdersRequest,
  DeleteProjectStakeholdersResponse,
  projectsRestResource,
  GetProjectTicketsRequest,
  GetProjectTicketsResponse,
  UploadRequirementsSheetRequest,
  UploadRequirementsSheetResponse,
  DownloadRequirementsSheetRequest,
  UpdateProjectMemoRequest,
  UpdateProjectMemoResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetProject = () =>
  useRestResourceHook<GetProjectRequest, GetProjectResponse>((request) =>
    projectsRestResource.getProject(request),
  );

export const useUpdateProject = () =>
  useRestResourceHook<UpdateProjectRequest, UpdateProjectResponse>((request) =>
    projectsRestResource.updateProject(request),
  );

export const useCreateProject = () =>
  useRestResourceHook<CreateProjectRequest, CreateProjectResponse>((request) =>
    projectsRestResource.createProject(request),
  );

export const useUpdateProjectStakeholders = () =>
  useRestResourceHook<
    UpdateProjectStakeholdersRequest,
    UpdateProjectStakeholdersResponse
  >((request) => projectsRestResource.updateProjectStakeholders(request));

export const useDeleteProjectStakeholders = () =>
  useRestResourceHook<
    DeleteProjectStakeholdersRequest,
    DeleteProjectStakeholdersResponse
  >((request) => projectsRestResource.deleteProjectStakeholders(request));

export const useGetProjectTickets = () =>
  useRestResourceHook<GetProjectTicketsRequest, GetProjectTicketsResponse>(
    (request) => projectsRestResource.getProjectTickets(request),
  );

export const useUploadRequirementsSheet = () =>
  useRestResourceHook<
    UploadRequirementsSheetRequest,
    UploadRequirementsSheetResponse
  >((request) => projectsRestResource.uploadRequirementsSheet(request));

export const useDownloadRequirementsSheet = () =>
  useRestResourceHook<DownloadRequirementsSheetRequest, void>((request) =>
    projectsRestResource.downloadRequirementsSheet(request),
  );

export const useUpdateProjectMemo = () =>
  useRestResourceHook<UpdateProjectMemoRequest, UpdateProjectMemoResponse>(
    (request) => projectsRestResource.updateProjectMemo(request),
  );
